import React from 'react';
import classNames from 'classnames';
import FeaturedCardPreview from '../featured-card-preview';
import styles from './style.module.scss';

interface MainBannerProps {
    userName?: string;
    coffeeCount?: number;
    showStar?: boolean;
    showGreeting?: boolean;
    image?: string;
    backgroundColor?: string | null;
    title?: string;
    titleColor?: string | null;
    subtitle?: string;
    subtitleColor?: string | null;
    cta?: string;
    className?: string;
}

const MainBanner: React.FC<MainBannerProps> = ({
    image,
    backgroundColor,
    title,
    titleColor,
    subtitle,
    subtitleColor,
    cta,
    className,
}) => {
    return (
        <div className={classNames(styles.mainBanner, className)}>
            <FeaturedCardPreview
                image={image}
                backgroundColor={backgroundColor}
                title={title}
                titleColor={titleColor}
                subtitle={subtitle}
                subtitleColor={subtitleColor}
                cta={cta}
            />
        </div>
    );
};

export default MainBanner;
